import React from 'react';
import Agreements from '../components/Agreements';

function AgreementsPage() {
  return (
    <Agreements/>
  );
}

export default AgreementsPage;